import { useQuery, useMutation, useQueryClient } from 'react-query';
import { api } from '#/apis';

const apiCalls = {};

apiCalls.fetchEmployees = async () => {
    const { data } = await api.get('/employees');

    return data;
};

apiCalls.fetchEmployee = async employeeId => {
    const { data } = await api.get(`/employees/${employeeId}`);

    return data;
};

apiCalls.createEmployee = async payload => {
    const { data } = await api.post('/employees', payload);

    return data;
};

apiCalls.updateEmployee = async (id, payload) => {
    const { data } = await api.put(`/employees/${id}`, payload);

    return data;
};

apiCalls.deleteEmployee = async employeeId => {
    const { data } = await api.delete(`/employees/${employeeId}`);

    return data;
};

export const useEmployee = (employeeId, queryOptions = {}) => useQuery(['employee', employeeId], () => apiCalls.fetchEmployee(employeeId), {
    cacheTime: 0,
    ...queryOptions
});

export const useEmployees = (queryOptions = {}) => useQuery('employees', apiCalls.fetchEmployees, queryOptions);

export const useUpdateEmployee = (queryOptions = {}) => {
    const queryClient = useQueryClient();

    return useMutation(({ id, payload }) => apiCalls.updateEmployee(id, payload), {
        onSuccess: () => {
            queryClient.invalidateQueries('employees');
            queryClient.invalidateQueries('department');
        },
        ...queryOptions
    });
};

export const useCreateEmployee = (queryOptions = {}) => {
    const queryClient = useQueryClient();

    return useMutation(payload => apiCalls.createEmployee(payload), {
        onSuccess: () => {
            queryClient.invalidateQueries('employees');
        },
        ...queryOptions
    });
};

export const useDeleteEmployee = (queryOptions = {}) => {
    const queryClient = useQueryClient();

    return useMutation(employeeId => apiCalls.deleteEmployee(employeeId), {
        onSuccess: () => {
            queryClient.invalidateQueries('employees');
        },
        ...queryOptions
    });
};
